import React from "react";
import CurrentCosts from "@SmartComponents/TenderEdit/Display/Boxes/CurrentCosts";
import NeedHelpBox from "@SmartComponents/TenderEdit/Display/Boxes/NeedHelpBox";
import styles from "./index.module.scss";
export default class RightGutter extends React.Component {
    render() {
        const { tender, isAdmin, customerName } = this.props;
        return (React.createElement("div", { className: styles.wrapper },
            isAdmin === true && customerName && (React.createElement("div", null,
                React.createElement("b", null, "Customer:"),
                " ",
                customerName)),
            React.createElement(CurrentCosts, { tender: tender }),
            React.createElement(NeedHelpBox, null)));
    }
}
